export class ServicioSolicitadoDTO {
    constructor(
        public idSucursal: number,
        public idServicio: number,
        public idCondicion: number,
        public cantidad: number,
        public tiempo: number,
        public descripcion: string,
        public filename: string
    ) {
        this.idSucursal = idSucursal;
        this.idServicio = idServicio;
        this.idCondicion = idCondicion;
        this.cantidad = cantidad;
        this.tiempo = tiempo;
        this.descripcion = descripcion;
        this.filename = filename;
    }
}
